import {
    actionSetUserFeatureMap,
} from '@/app/shared/utils/stateActionUtils';

import {
    SET_PANEL,
    SET_FILTERS_MAP,
    UPDATE_FILTER_ITEM_MAP,
} from './mutation-types';

const actions = {
    setPanels ({ dispatch }, panels){
        if(panels){
            for(let e=0, elen=panels.length; e<elen; e++){
                let panel = panels[e];
                if(panel.id){
                    dispatch('setPanel', panel);
                }
            }
        }
    },
    setPanel ({ commit }, {id, ...params}){
        commit(SET_PANEL, {id, ...params});
    },
    openPanel ({ commit }, id){
        commit(SET_PANEL, {id, show: true});
    },
    closePanel ({ commit }, id){
        commit(SET_PANEL, {id, show: false});
    },
    togglePanel ({ commit, getters }, id){
        commit(SET_PANEL, {id, show: !getters.getPanelStatus(id)});
    },
    closeAllPanels ({ commit, getters }){
        let panels = getters.getPanels;
        for(let e=0, elen=panels.length; e<elen; e++){
            let panel = panels[e];
            if(panel.id){
                if(panel.showDefault !== undefined && panel.showDefault){
                    continue;
                }
                commit(SET_PANEL, {id: panel.id, show: false});
            }
        }
    },
    async setUserFeatureMap ({ commit }, feature) {
        await actionSetUserFeatureMap(this._vm, commit, feature);
    },
    setFiltersMap ({ commit }, filters){
        commit(SET_FILTERS_MAP, filters);
    },
    async toggleFilterMap ({ commit, state }, {tp, id}){
        let item = state.data.map.filters[tp].find( item => item.id == id);
        let show = !item.show;
        commit(UPDATE_FILTER_ITEM_MAP, {tp: tp, id: id, show: show});
        let sub_items = tp=='years' ? item.types : item.years;
        for(let sub_id in sub_items){
            let qty = sub_items[sub_id];
            if(qty){
                let state_items = tp=='years' ? state.data.map.filters.types : state.data.map.filters.years;
                let state_item = state_items.find(item => item.id == parseInt(sub_id));
                if(state_item && state_item.qty !== 'undefined'){
                    // state_item.qty = item.show ? state_item.qty + qty : state_item.qty - qty;
                    let new_qty = item.show ? state_item.qty + qty : state_item.qty - qty;
                    commit(UPDATE_FILTER_ITEM_MAP, {tp: 'types', item: state_item, qty: new_qty});
                }
            }
        }
    },
    updateFilterMap ({ commit, state }, obj){
        Object.entries(obj).forEach(([tp, val]) => {
            let from = val.from;
            let to = val.to;
            if(from != to){
                if(from) {
                    let f_item = state.data.map.filters[tp].find(x => x.id == from);
                    commit(UPDATE_FILTER_ITEM_MAP, {tp: tp, item: f_item, qty: f_item.qty-1});
                }
                if(to) {
                    let t_item = state.data.map.filters[tp].find(x => x.id == to);
                    commit(UPDATE_FILTER_ITEM_MAP, {tp: tp, item: t_item, qty: t_item ? t_item.qty + 1 : 1});
                }
            }
        });
    },
    toggleCollapseFilterMap ({ commit, getters }, id){
        commit(SET_PANEL, {id, collapsed: !getters.getPanel(id).collapsed});
    },
};

export default actions;
